import { ApplicationInsights, SeverityLevel } from "@microsoft/applicationinsights-web";
import * as envConfig from "../../config.json";
import AppTracking from "./index";

const { instrumentationKey, isAppInsightEnabled, isTrackTraceEnabled, isTrackExceptionEnabled, isTrackEventEnabled } = envConfig["CONFIG"];

class AppInsight {
    id: any;
    appInsights: any;
    webAppName: any;
    constructor() {
        this.id = AppTracking.id;
        this.webAppName = "Residential Warranty Registration";
        if (isAppInsightEnabled) {
            this.appInsights = new ApplicationInsights({
                config: {
                    instrumentationKey: instrumentationKey,
                    disableFetchTracking: false,
                },
            });
            this.appInsights.loadAppInsights();
            const telemetryInitializer = (envelope) => {
                envelope.tags.push({ "ai.operation.id": this.id });
                envelope.data["ApplicationName"] = this.webAppName;
            };
            this.appInsights.addTelemetryInitializer(telemetryInitializer);
        }
    }
    updateOperationId = (id?: any) => {
        AppTracking.updateTrackingId(id);
        this.id = AppTracking.id;
    };
    trackPageView = () => {
        if (isAppInsightEnabled) {
            this.updateOperationId();
            this.appInsights.trackPageView();
        }
    };
    trackTrace = (msg: string) => {
        if (isAppInsightEnabled && isTrackTraceEnabled) {
            this.appInsights.trackTrace({
                message: `${this.webAppName}: ${msg}`,
                severityLevel: SeverityLevel.Information,
            });
        }
    };
    trackException = (error: any) => {
        if (isAppInsightEnabled && isTrackExceptionEnabled) {
            if (!Error.prototype.isPrototypeOf(error)) {
                this.appInsights.trackException({
                    error: new Error(JSON.stringify(error)),
                    severityLevel: SeverityLevel.Error,
                });
            } else this.appInsights.trackException({ error, severityLevel: SeverityLevel.Error });
        }
    };
    trackEvent = (msg: string) => {
        if (isAppInsightEnabled && isTrackEventEnabled) {
            this.appInsights.trackEvent({ name: `${this.webAppName}: ${msg}` });
        }
    };
}

window["AppInsightTrace"] = new AppInsight();
